export default __webpack_public_path__ + "57b774fb49ce4de61446af7ff494bfdc.jpg";